/**
 * @file avatarTrace.js
 * @description Trazas controladas para diagnostico de avatar en UI real.
 */

function getTraceStore() {
  if (typeof window === 'undefined') return null;
  if (!(window.__archatAvatarTraceStore instanceof Set)) {
    window.__archatAvatarTraceStore = new Set();
  }
  return window.__archatAvatarTraceStore;
}

export function isAvatarTraceEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    return window.__ARCHAT_AVATAR_TRACE__ === true || localStorage.getItem('archat_avatar_trace') === '1';
  } catch {
    return window.__ARCHAT_AVATAR_TRACE__ === true;
  }
}

export function logAvatarTrace(scope, payload, onceKey = '') {
  if (!isAvatarTraceEnabled()) return;
  if (typeof console === 'undefined') return;
  const store = getTraceStore();
  if (onceKey && store) {
    if (store.has(onceKey)) return;
    store.add(onceKey);
  }
  console.info(`[AVATAR TRACE][${scope}]`, payload);
}

